"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WishlistEvent = void 0;
const uuid = require("uuid");
class WishlistEvent {
    constructor(timestamp) {
        this.timestamp = timestamp;
    }
    static generateId() {
        return uuid.v4();
    }
}
exports.WishlistEvent = WishlistEvent;
